/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Terminal reduced object
*/
export class TerminalReduced {
    'id': number;
    'name': string;
    'logoUrl': string;
    'latPosition': number;
    'lonPosition': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "logoUrl",
            "baseName": "logoUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "latPosition",
            "baseName": "latPosition",
            "type": "number",
            "format": "double"
        },
        {
            "name": "lonPosition",
            "baseName": "lonPosition",
            "type": "number",
            "format": "double"
        }    ];

    static getAttributeTypeMap() {
        return TerminalReduced.attributeTypeMap;
    }

    public constructor() {
    }
}

